"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _EnhancedTableToolbar = _interopRequireDefault(require("./EnhancedTableToolbar"));
const EnhancedTableToolbarV2 = _ref => {
  let {
    selectedRowsCount,
    pagesCount,
    renderNumSelectedText,
    rowsCount,
    topBarButtons,
    topBarSelectionConfig
  } = _ref;
  const _topBarSelectionConfig = (0, _react.useMemo)(() => {
    if (!topBarSelectionConfig) {
      return topBarSelectionConfig;
    }
    const {
      renderEnhancedNumSelectedText,
      renderSelectAllText
    } = topBarSelectionConfig;
    return {
      ...topBarSelectionConfig,
      renderEnhancedNumSelectedText: () => renderEnhancedNumSelectedText && renderEnhancedNumSelectedText(selectedRowsCount || 0, pagesCount) || '',
      renderSelectAllText: () => renderSelectAllText && renderSelectAllText(rowsCount) || ''
    };
  }, [topBarSelectionConfig, selectedRowsCount, rowsCount, pagesCount]);
  if (topBarSelectionConfig) {
    return /*#__PURE__*/_react.default.createElement(_EnhancedTableToolbar.default, {
      numSelected: selectedRowsCount,
      topBarButtons: topBarButtons,
      topBarSelectionConfig: _topBarSelectionConfig,
      isAllSelected: rowsCount === selectedRowsCount,
      renderNumSelectedText: renderNumSelectedText
    });
  }
  return /*#__PURE__*/_react.default.createElement(_EnhancedTableToolbar.default, {
    numSelected: selectedRowsCount,
    renderNumSelectedText: renderNumSelectedText,
    topBarButtons: topBarButtons
  });
};
var _default = exports.default = EnhancedTableToolbarV2;